//Comentario necesario para codificación en UTF-8, ver Inc6743
(function () {
	var App = angular.module('pphhApp');
	
	App.service("lockVersionActionController", [ "$mdDialog", "$q", "CRUDService", LockVersionActionController ]);
	App.service("unlockVersionActionController", [ "$mdDialog", "$q","CRUDService", UnlockVersionActionController ]);

	function LockVersionActionController($mdDialog, $q, crudService) {
		var helper = new LockVersionHelper($mdDialog, crudService);
		
		this.performAction = performAction;
		

		function performAction(scope) {
			var deferred = $q.defer();
			
			helper.performAction(deferred, scope, true);
			
			return deferred.promise;
		}
	}
	
	function UnlockVersionActionController($mdDialog, $q, crudService) {
		var helper = new LockVersionHelper($mdDialog, crudService);
		
		this.performAction = performAction;

		function performAction(scope) {
			var deferred = $q.defer();
			
			helper.performAction(deferred, scope, false);
			
			return deferred.promise;
		}
	}
	
	function LockVersionHelper($mdDialog, crudService) {
		this.performAction = performAction;
		
		function performAction(deferred, scope, value) {
			var confirm = null;
			if(value) {
				confirm = $mdDialog.confirm()
					.clickOutsideToClose(true)
					.title(UIMessages.dialog.confirm.title)
					.htmlContent(UIMessages.visor.lockCiclo)
					.ok(UIMessages.dialog.confirm.ok)
					.cancel(UIMessages.dialog.confirm.cancel)
					;
			} else {
				confirm = $mdDialog.confirm()
					.clickOutsideToClose(true)
					.title(UIMessages.dialog.confirm.title)
					.htmlContent(UIMessages.visor.unlockCiclo)
					.ok(UIMessages.dialog.confirm.ok)
					.cancel(UIMessages.dialog.confirm.cancel)
					;
			}
			$mdDialog.show(confirm)
			.then(
					function () {
						scope.isLoading = true;
						crudService.lockCiclo(value).then(
								function (response) {
									scope.lockedCiclo = response.data;
									scope.isLoading = false;
									deferred.resolve();
								},
								function () {
									deferred.reject();
									scope.isLoading = false;
								}
						);
					},
					function () {
						deferred.reject();
					}
			);
		}
	}

})();